import { Components, Theme } from '@mui/material';

export const MuiButtonBase: Components<Theme>['MuiButtonBase'] = {
  defaultProps: {
    draggable: false,
  },
  styleOverrides: {
    root: {
      WebkitUserDrag: 'none',
      WebkitTouchCallout: 'none',
    },
  },
};
